import axios from 'axios';
import authToken from './authToken';
import cfac22 from '../cfac22';

export function getPartnerFiles(partnerId, type, status) {
  return new Promise((resolve, reject) => {
    authToken().then((token) => {
      // Monta os parâmetros dinamicamente
      const params = new URLSearchParams({ partnerId });

      if (type) params.append('type', type);
      if (status) params.append('status', status);

      const url = `${cfac22('API_HOST_V2')}/partnerFiles/getPartnerFiles?${params.toString()}`;

      axios
        .get(url, {
          headers: {
            authorization: 'Bearer ' + token,
            'Full-Url': window.location.href,
          },
        })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => {
          reject(error?.response?.data?.result || error.message);
        });
    });
  });
}
